import { combineReducers } from "redux";
import authSlice from "app/slice/authSlice";
import featuresReducer from "app/reducers/featuresReducer";

export default combineReducers({
    auth:authSlice,
    features:featuresReducer,
});
